import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import './LandingPageHero.css'



export default class ProductLandingHero extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
      isValid: false,
      emailValid: false,
      email: '',
      phoneValid: false,
      phone: '',
      nameValid: false,
      name: '',
      companyValid: false,
      company: '',
      commentValid: false,
      errorMsg: [],
      bannedMail: '',
      appended: false
    }
  }

  formValidator = () => {
    let emailField;
    let phoneField;
    let nameField;
    let companyField;
    let commentField;

    if (this.props.embed === '33') {
      emailField = document.getElementById('email');
      phoneField = document.getElementById('phone');
      nameField = document.getElementById('fullname');
      companyField = document.getElementById('field[18]');
      commentField = document.getElementById('field[27]');
      this.setState({ email: emailField.value, phone: phoneField.value, name: nameField.value, company: companyField.value });
    }
    else if (this.props.embed === '52' || this.props.embed === '54') {
      emailField = document.getElementById('email');
      phoneField = document.getElementById('phone');
      nameField = document.getElementById('fullname');
      commentField = document.getElementById('field[27]');
      this.setState({ email: emailField.value, phone: phoneField.value, name: nameField.value });
    }
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/;
    console.log('form change has fired');
    let stateVar = this.state;
    let button = document.getElementById('_form_' + this.props.embed + '_submit');


    button.classList.add('disabled');
    let commentLastChar = commentField.value.charAt(commentField.value.length - 1);
    this.validatorChecker(stateVar, button);

    //Check if provided email is banned
    let bannedMails = ['drivem.my.id', 'vivaldigital.com', 'mdriveku.my.id', 'gdriveme.id', 'bozzcello.com', 'keyestate.ooo', 'microsoft.com'];
    if (bannedMails.some((item) => this.state.email.includes(item))) {
      this.setState({ bannedMail: true })
    } else {
      this.setState({ bannedMail: false })
    }
    if (emailField.value.match(emailRegex) && this.state.bannedMail === false) {
      let msg = "Please input correct email address"
      this.setState({ emailValid: true })
      emailField.style.border = "none";
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
    } else {
      emailField.style.borderBottom = "thick solid red";
      let msg = "Please input correct email address"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] }, this.validatorChecker(stateVar, button))
      }
      this.setState({ emailValid: false }, this.validatorChecker(stateVar, button))
    }

    if (phoneField.value.match(phoneRegex)) {
      this.setState({ phoneValid: true }, this.validatorChecker(stateVar, button))
      phoneField.style.border = "none";
      let msg = "Please input a valid phone number"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
    } else {
      this.setState({ phoneValid: false }, this.validatorChecker(stateVar, button))
      phoneField.style.borderBottom = "thick solid red";
      let msg = "Please input a valid phone number"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] }, this.validatorChecker(stateVar, button))
      }
    }
    if (companyField !== undefined && this.props.embed === '33') {
      if (companyField.value.toLowerCase() !== nameField.value.toLowerCase()) {
        this.setState({ companyValid: true, nameValid: true }, this.validatorChecker(stateVar, button))
        companyField.style.border = "none";
        nameField.style.border = "none";
        let msg = "Full name and company name cannot be the same"
        let index = this.state.errorMsg.indexOf(msg)
        if (index > -1) {
          this.state.errorMsg.splice(index, 1)
        }
        this.nameFieldCheck(nameField, this.validatorChecker(stateVar, button));
        this.companyFieldCheck(companyField, this.validatorChecker(stateVar, button));
      } else {

        this.nameFieldCheck(nameField, this.validatorChecker(stateVar, button));
        this.companyFieldCheck(companyField, this.validatorChecker(stateVar, button));

        companyField.style.borderBottom = "thick solid red";
        nameField.style.borderBottom = "thick solid red";
        let msg = "Full name and company name cannot be the same"

        if (!this.state.errorMsg.includes(msg)) {
          this.setState({ errorMsg: [...this.state.errorMsg, msg] }, this.validatorChecker(stateVar, button))
        }
        this.setState({ companyValid: false, nameValid: false }, this.validatorChecker(stateVar, button))
      }
    }
    this.nameFieldCheck(nameField, this.validatorChecker(stateVar, button));

    if (commentLastChar !== '-') {
      commentField.style.border = "none";
      let msg = "Inserted comment is incorrect"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
      this.setState({ commentValid: true }, this.validatorChecker(stateVar, button))
    } else {
      commentField.style.borderBottom = "thick solid red";
      let msg = "Inserted comment is incorrect"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] }, this.validatorChecker(stateVar, button))
      }
      this.setState({ commentValid: false }, this.validatorChecker(stateVar, button))
    }
  }




  nameFieldCheck = (nameField) => {
    if (nameField.value !== "." && nameField.value !== "-") {
      this.setState({ nameValid: true })
      let msg = "Please input a valid name"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
      nameField.style.border = "none";
    } else {
      this.setState({ nameValid: false })
      let msg = "Please input a valid name"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] })
      }
      nameField.style.borderBottom = "thick solid red";
    }
  }

  companyFieldCheck = (companyField) => {
    if (companyField.value !== "dol" && companyField.value !== "dol-sensors" && companyField.value !== "dol sensors" && !companyField.value.includes('@')) {
      let msg = "Invalid company name"
      let index = this.state.errorMsg.indexOf(msg)
      if (index > -1) {
        this.state.errorMsg.splice(index, 1)
      }
      companyField.style.borderBottom = "none"
      this.setState({ companyValid: true })
    } else {
      this.setState({ companyValid: false })
      let msg = "Invalid company name"
      if (!this.state.errorMsg.includes(msg)) {
        this.setState({ errorMsg: [...this.state.errorMsg, msg] })
      }
      companyField.style.borderBottom = "thick solid red"
    }
  }

  validatorChecker = (stateVar, button) => {
    console.log(stateVar)
    if (stateVar.emailValid && stateVar.commentValid && stateVar.nameValid && stateVar.phoneValid) {
      this.setState({ isValid: true }, this.buttonEnabler(button))
    } else {
      this.setState({ isValid: false }, this.buttonDisabler(button))
    }
  }

  buttonEnabler = (button) => {
    button.removeAttribute('disabled')
    button.classList.remove('disabled')
  }

  buttonDisabler = (button) => {
    button.disabled = 'true'
    button.classList.add('disabled')
  }



  componentDidMount() {
    const { embed } = this.props;
    let formElement = document.getElementById(`form-container-${embed}-lph`);
    this.appendForm(embed, formElement);

    //const script = document.createElement('script');
    const pageUrl = window.location.href;
    //script.src = `https://dol-sensors67660.activehosted.com/f/embed.php?id=${embed}`
    //script.async = true
    //script.setAttribute('id', 'activecampaign-script')
    //document.body.appendChild(script)


    //Add validator to the form 33 - eng 52 - german 54 - spanish
    if (this.props.embed === '1230' ) {
      formElement.addEventListener("change", this.formValidator);
    }

    //Wait for changes in the form
    const observer = new MutationObserver(() => {

      //Change form's input value
      let inputField = document.getElementById('field[1]');
      if (typeof (inputField) !== 'undefined' && inputField !== null) {
        inputField.value = 'website';
      }
      //Attach URL to the form field
      let signupField = document.getElementsByName("field[26]");
      let signupArr = [...signupField]
      if (signupArr.length > 0) {
        signupArr[0].value = pageUrl;
      }

      //Hiding honeypot element
      let honeyPot = document.getElementsByClassName('_x57317928')[0]
      if (honeyPot !== undefined) {
        honeyPot.style.display = 'none';
      }

    });

    //Observe for changes in the form's child list
    observer.observe(formElement, {
      childList: true
    })
  }

  //Create form tooltip
  createTooltip = (message) => {
    const tooltip = document.createElement('div');
    tooltip.innerText = message;
    tooltip.style.position = 'absolute';
    tooltip.style.background = '#333';
    tooltip.style.color = '#fff';
    tooltip.style.padding = '5px 10px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.fontSize = '12px';
    tooltip.style.display = 'none';
    tooltip.style.zIndex = '1000';
    return tooltip;
  };

  //Append a form
  appendForm = (embed, formEl) => {
    if (this.state.appended === false) {
      this.setState({ appended: true }, function () {
        const script = document.createElement('script');
        script.src = `https://dol-sensors67660.activehosted.com/f/embed.php?id=${embed}`
        script.async = true
        script.setAttribute('id', 'activecampaign-script')
        document.body.appendChild(script)

        //Check if the form exist and add an eventListener
        script.onload = () => {
          if (formEl) {
            const fullNameInput = formEl.querySelector('input[name="fullname"]');
            const submitButton = formEl.querySelector(`#${'_form_' + embed + '_submit'}`)
            //If form has a fullname input field check if there is a space (So we know it is a first and a last name)
            if (fullNameInput) {
              const tooltip = this.createTooltip('Please enter your first and last name');
              formEl.appendChild(tooltip); // Append tooltip to the body
              const containerRect = fullNameInput.getBoundingClientRect()
              // Position tooltip and display it on focus
              fullNameInput.addEventListener('focus', (e) => {
                const rect = e.target.getBoundingClientRect();
                //tooltip.style.bottom = `${rect.top - rect.height*1.3}px`;
                //tooltip.style.width = `${rect.width}px`
                if (this.state.validated === false) {
                  tooltip.style.display = 'block';
                  submitButton.setAttribute('disabled', 'true')
                }
              });


              fullNameInput.addEventListener('input', (e) => {
                const fullName = e.target.value.trim();
                if (!/^\S+\s+\S+/.test(fullName)) {
                  e.target.style.borderColor = 'red';
                  tooltip.style.display = 'block';
                  this.setState({ validated: false })
                  if (!submitButton.hasAttribute('disabled')) {
                    submitButton.setAttribute('disabled', 'true');
                  }
                } else {
                  e.target.style.borderColor = '';
                  tooltip.style.display = 'none';
                  this.setState({ validated: true })
                  if (submitButton.hasAttribute('disabled')) {
                    submitButton.removeAttribute('disabled')
                  }
                }
              })
            }
          }
        }
      })
    }
  }

  hex2rgb = (background) => {
    let pattern_color = "^#([A-Fa-f0-9]{6})$";
    let hex_color = background.bg_color;
    let rgb_color;
    let a = background.opacity / 100;
    if (hex_color.match(pattern_color)) {
      hex_color = hex_color.replace("#", "")
      let r = parseInt(hex_color.substring(0, 2), 16)
      let g = parseInt(hex_color.substring(2, 4), 16)
      let b = parseInt(hex_color.substring(4, 6), 16);
      return rgb_color = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    }
    else {
      alert('Error Color Format');
    }
  }



  render() {
    const {
      title,
      text,
      backgroundImage,
      embed,
      overlay,
      form_bg,
      text_color
    } = this.props



    return (
      <Wrapper image={backgroundImage && backgroundImage.sourceUrl} overlayColor={this.hex2rgb(overlay)}>
        {console.log()}
        <Content>
          <Container fluid className="height100">
            <Row alignItems="start" className="height100 mt-3">
              <Col md={6} className="title-column">
                <Title>{title}</Title>
                <Text dangerouslySetInnerHTML={{ __html: text }} />
              </Col>
              <Col md={6} className="buttonWrapper">
                <Form onChange={this.formChecker} className={`_form_${embed} mx-auto`} id={`form-container-${embed}-lph`} bgColor={this.hex2rgb(form_bg)} textColor={text_color} embed={embed} />
                {this.state.isValid === false &&
                  <Error>{this.state.errorMsg[0]}</Error>
                }
              </Col>
            </Row>
          </Container>
        </Content>
      </Wrapper>
    )
  }

}
// Styles
const Wrapper = styled.section`
  background: url(${props => props.image}) center / cover;
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 65px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &&::before {
    content: "";
    position: absolute;
    left: 0; right: 0;
    top: 0; bottom: 0;
    background: ${props => props.overlayColor};
  }
`

const Content = styled.div`
  height: 100%;
  position: relative;
  z-index: 1;
  width: 100%;
  padding-top: 5%;
  padding-bottom: 50px;
`




const Text = styled.div`
  font-size: 25px;
  color: white;
  font-weight: 300;

  a {
    color: white !important;
    text-decoration: underline !important; 
  }
`

const Title = styled.h1`
  font-size: 80px;
  color: white;
  line-height: 100px;

  ${media.xs`
    font-size: 40px;
    line-height: normal;
    margin-bottom: 25px;
  `}
`
const Error = styled.p`
margin: auto;
background-color: #ff00005e;
width: 70%;
text-align: center;
color: aliceblue;
`

const Form = styled.div`
&&#form-container-${props => props.embed}-lph {
    * {
      font-family: "Work Sans";
      color: ${props => props.textColor};
      font-size: 16px;
    }

    ._field1, ._x29757849 {
      display: none;
    }


    form {
      width: 100%;
      padding: 20px;
      max-width: 700px !important;
      //background: none !important;
      background: ${props => props.bgColor} !important;
    }

    p {
      font-size: 16px !important;
    }

    ._form-content{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    ._x06147226 {
      width: 40%;
      flex-grow: 2;
    }

    ._x74459413 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field32 {
      width: 40%
      flex-grow: 2;
    }

    
    ._field32 option {
      width: 80%;
      color: black;
    } 

    ._field57 {
      width: 40%;
      flex-grow: 2;
      margin-left: 5%;
    }

    ._field57 option {
      color: black;
      width: 80%;
    }

    ._form-title {
      font-weight: 300;
      font-size: 30px;
      line-height: 45px;
    }

    ._form-label {
      font-weight: 500;
    }

    ._form_element {
      margin-bottom: 1.5em;
    }
    
    ._form-branding {
        display:none;
    }

    ._field-wrapper {
      select,
      input,
      option {
        background: white;
        color: black !important;
        border: none;
        border-radius: 0;
        padding: 1em 0.5em;

        &::placeholder {
          color: white;
        }
      }
    }



    textarea:focus {
      height: 8em !important;
    }




    ._submit {
      background: #00994c !important;
      text-transform: uppercase;
      border-radius: 2em !important;
      padding: 0.5em 1.5em !important;
      transition: all .2s ease-in-out !important;
    }

    ._submit:hover {
      background: #00994cad !important;
    }

    .disabled {
      background-color: grey !important;
    }

    .disabled:hover{
      background-color: grey !important;
    }



  }

  ${media.sm`
  width: 100%;
`}
`


// WEBPACK FOOTER //
// ./src/ui/components/modules/LandingPageHero/index.js